export default function() {
  const widgetName = 'cardWidgetEvents';
  const widgetOpts = cardWidgetEventsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function(i, item) {
        if (data.items[i].DateRange) {
          var rawDate = data.items[i].DateRange.slice(0, 7);
          var m = rawDate.slice(0, 4).trim();
          var d = rawDate.replace(",", "").slice(-3).trim();

          $(this).prepend(`
            <div class="card-widget-date">
              <span>${m}</span>
              <span>${d}</span>
            </div>
          `);
        }
      });

      var eventTitles = $("#cardWidgetEvents .card-widget-title");

      eventTitles.each(function() {
        var titleText = $(this).text();

        if (titleText.length > 45) {
          var truncatedText = titleText.substring(0, 45) + "...";
          $(this).text(truncatedText);
        }
      });

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true
  });

}